import { aTrack } from '../primitives/a-track';
const ONE_ASSET = '1-asset';
const ALL_ASSET = 'all-asset';
class EarnTabEvent {
    constructor(pool) {
        // pool is optional
        this.options = {
            origin: 'earn_tab',
        };
        if (pool) {
            this.withPool(pool);
        }
    }
    withPool(pool) {
        const pool_id = pool.address;
        const pool_tokens = pool.tokens.map(t => t.symbol);
        this.options = Object.assign({ pool_id: pool_id, pool_tokens: pool_tokens }, this.options);
        return this;
    }
    clicked_earn_tab() {
        aTrack('clicked_earn_tab', this.options);
    }
    hover_net_apr_tooltip(step) {
        aTrack('hover_net_apr_tooltip', this.options, { isHover: true, step });
    }
    hover_swaap_coins_tip(step) {
        aTrack('hover_swaap_coins_tip', this.options, { isHover: true, step });
    }
    hover_volume_tooltip(step) {
        aTrack('hover_volume_tooltip', this.options, { isHover: true, step });
    }
    clicked_deposit() {
        aTrack('clicked_deposit', this.options);
    }
    clicked_settings(deposit_tab, current_slippage) {
        aTrack('clicked_settings', Object.assign({ deposit_tab,
            current_slippage }, this.options));
    }
    changed_slippage_tolerance(deposit_tab, previous_slippage, new_slippage) {
        aTrack('changed_slippage_tolerance', Object.assign({ deposit_tab,
            previous_slippage,
            new_slippage }, this.options));
    }
    clicked_one_asset_tab(default_token) {
        aTrack('clicked_one_asset_tab', Object.assign({ deposit_tab: ONE_ASSET, default_token }, this.options));
    }
    clicked_all_asset_tab(tokens) {
        aTrack('clicked_all_asset_tab', Object.assign({ deposit_tab: ALL_ASSET }, this.options));
    }
    opened_token_selector(deposit_tab, token) {
        aTrack('opened_token_selector', Object.assign({ deposit_tab,
            token }, this.options));
    }
    selected_token(deposit_tab, previous_token, new_token) {
        aTrack('selected_token', Object.assign({ deposit_tab,
            previous_token,
            new_token }, this.options));
    }
    clicked_max_token(deposit_tab, token, amount) {
        aTrack('clicked_max_token', Object.assign({ deposit_tab,
            token,
            amount }, this.options));
    }
    entered_amount_token(deposit_tab, token, amount) {
        aTrack('entered_amount_token', Object.assign({ deposit_tab: deposit_tab, token,
            amount }, this.options), { isDebounced: true });
    }
    clicked_preview_deposit(deposit_tab, bring_in) {
        aTrack('clicked_preview_deposit', Object.assign({ deposit_tab,
            bring_in }, this.options));
    }
    clicked_confirmed_deposit(deposit_tab, mode, bring_in, token_amounts, expected_minted_shares, minimal_minted_shares) {
        let options = {
            deposit_tab,
            mode,
            bring_in,
            token_amounts,
        };
        if (deposit_tab === '1-asset') {
            options.expected_minted_shares = expected_minted_shares;
            options.minimal_minted_shares = minimal_minted_shares;
        }
        else {
            options.exact_minted_shares = expected_minted_shares;
        }
        aTrack('clicked_confirmed_deposit', Object.assign(Object.assign({}, options), this.options));
    }
    clicked_withdraw() {
        aTrack('clicked_withdraw', this.options);
    }
    clicked_percentage_withdraw(percentage_value) {
        aTrack('clicked_percentage_withdraw', Object.assign({ percentage_value }, this.options));
    }
    entered_percentage_withdraw(percentage_value) {
        aTrack('entered_percentage_withdraw', Object.assign({ percentage_value }, this.options), { isDebounced: true });
    }
    percentage_withdraw_fail(percent, error) {
        aTrack('percentage_withdraw_fail', Object.assign({ percent, error }, this.options));
    }
    clicked_preview_withdraw(burned_shares, expected_outputs) {
        aTrack('clicked_preview_withdraw', Object.assign({ burned_shares,
            expected_outputs }, this.options));
    }
    clicked_confirmed_withdraw() {
        aTrack('clicked_confirmed_withdraw', Object.assign({}, this.options));
    }
}
export function createEarnTabEvent(pool) {
    return new EarnTabEvent(pool);
}
//# sourceMappingURL=earn-tab.js.map